import { Plugin, PluginType, } from '@segment/analytics-react-native';
import { Dimensions, PixelRatio } from 'react-native';
const PIXEL_DENSITY = PixelRatio.get();
export class ScreenEnrichmentPlugin extends Plugin {
    type = PluginType.enrichment;
    execute(event) {
        if (event.context &&
            event.context?.screen &&
            event.context.screen.density === undefined) {
            event.context.screen.density = PIXEL_DENSITY;
        }
        if (event.context && !event.context?.screen) {
            const { width, height } = Dimensions.get('screen');
            event.context.screen = {
                width,
                height,
                density: PIXEL_DENSITY,
            };
        }
        return event;
    }
}
//# sourceMappingURL=ScreenEnrichmentPlugin.js.map